import Woff from "./BuenosAiresWeb-Thin.woff";
import Woff2 from "./BuenosAiresWeb-Thin.woff2";

const font = {
  fontFamily: "BuenosAiresWeb",
  fontStyle: "normal",
  fontWeight: 200,
  src: [
    `url(${Woff2}) format('woff2')`,
    `url(${Woff}) format('woff')`,
  ].join(","),
  unicodeRange: "U+000D-FB04",
};

export default font;